import UpdateProfileModal from '@/components/modal/UpdateProfileModal.vue'
import UpdatePasswordModal from '@/components/modal/UpdatePasswordModal.vue'
import DeleteAccountModal from '@/components/modal/DeleteAccountModal.vue'

import { useModalSlot } from 'vue-final-modal'
import { useCustomModal } from '~/modalHelper'
import { useIsTempUser } from '~/composables/useAuthenticated'

const getUpdateProfileModalConfig = () => ({
  attrs: {
    modalId: 'update_profile',
    title: 'Mes informations',
    clickToClose: false,
  },
  slots: {
    default: useModalSlot({
      component: UpdateProfileModal,
      attrs: {
        onOpenUpdatePasswordModal,
        onDeleteAccountModal,
      },
    }),
  },
})

const getUpdatePasswordModalConfig = () => ({
  attrs: {
    modalId: 'update_password',
    title: 'Modifier mon mot de passe',
    clickToClose: false,
    onClosed: resetUpdateProfileModal,
  },
  slots: {
    default: useModalSlot({
      component: UpdatePasswordModal,
      attrs: {
        onOpenUpdateProfileModal,
      },
    }),
  },
})

const getDeleteAccountModalConfig = () => ({
  attrs: {
    modalId: 'delete_account',
    title: 'Supprimer mon compte',
    clickToClose: false,
    onClosed: resetUpdateProfileModal,
  },
  slots: {
    default: useModalSlot({
      component: DeleteAccountModal,
    }),
  },
})

// a Google sign-up still to finalize (temporary account) gets the short form, "Dernière étape"; any other
// account its profile, "Mes informations". Set at each opening: the config is built once, before any session
const updateProfileTitle = () =>
  useIsTempUser().value ? 'Dernière étape' : 'Mes informations'

const resetUpdateProfileModal = () => {
  updateProfileModal.patchOptions(getUpdateProfileModalConfig())
  updateProfileModal.patchOptions({ attrs: { title: updateProfileTitle() } })
}

const onDeleteAccountModal = async () => {
  updateProfileModal.patchOptions(getDeleteAccountModalConfig())
}

const onOpenUpdatePasswordModal = async () => {
  updateProfileModal.patchOptions(getUpdatePasswordModalConfig())
}

const onOpenUpdateProfileModal = async () => {
  resetUpdateProfileModal()
}

export const updateProfileModal = useCustomModal(getUpdateProfileModalConfig())

const openUpdateProfileModal = updateProfileModal.open
updateProfileModal.open = () => {
  updateProfileModal.patchOptions({ attrs: { title: updateProfileTitle() } })
  return openUpdateProfileModal()
}
